import { SUB_WEBSITE } from './const'

/*
 根据提供的子网站ID，返回相应的网站信息对象。
 该对象包含标识网站类型的布尔值以及默认语言。
 @param subWebsiteId - 子网站的唯一标识符。
 @returns 一个对象，包含网站的类型标识和默认语言信息。
*/
export const getWebsite = (subWebsiteId: number) => {
  const {
    SUB_WEBSITE_ID_MAIN,
    SUB_WEBSITE_ID_TURKEY,
    SUB_WEBSITE_ID_MALTA,
    SUB_WEBSITE_ID_HONGKONG,
    SUB_WEBSITE_ID_US,
    SUB_WEBSITE_ID_UK,
    SUB_WEBSITE_ID_JP,
    SUB_WEBSITE_ID_UAE,
    SUB_WEBSITE_ID_EU,
  } = SUB_WEBSITE

  const langList: {
    [key: number]: string
  } = {
    [SUB_WEBSITE_ID_MAIN]: 'en',
    [SUB_WEBSITE_ID_TURKEY]: 'tr',
    [SUB_WEBSITE_ID_MALTA]: 'en',
    [SUB_WEBSITE_ID_HONGKONG]: 'en',
    [SUB_WEBSITE_ID_US]: 'en',
    [SUB_WEBSITE_ID_UK]: 'en',
    [SUB_WEBSITE_ID_JP]: 'en',
    [SUB_WEBSITE_ID_UAE]: 'en',
    [SUB_WEBSITE_ID_EU]: 'en',
  }

  return {
    isMain: subWebsiteId === SUB_WEBSITE_ID_MAIN,
    isTurkey: subWebsiteId === SUB_WEBSITE_ID_TURKEY,
    isMalta: subWebsiteId === SUB_WEBSITE_ID_MALTA,
    isEU: subWebsiteId === SUB_WEBSITE_ID_EU,
    isHongKong: subWebsiteId === SUB_WEBSITE_ID_HONGKONG,
    isUnitedStates: subWebsiteId === SUB_WEBSITE_ID_US,
    isJapan: subWebsiteId === SUB_WEBSITE_ID_JP,
    isUAE: subWebsiteId === SUB_WEBSITE_ID_UAE,
    isUK: subWebsiteId === SUB_WEBSITE_ID_UK,
    defaultLang: langList[subWebsiteId] || 'en',
    subWebsiteId,
  }
}
